// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import '@/common/common.css';
import '@/common/variable.scss'
import {wordData,json} from '@/common/common.js'
import '@/common/variable.scss'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import QRCode from 'qrcode'
import sysConfig from '@/common/sys-config.js'

// 标签组件
import tagSelect from '@/components/tagSelect'

// 复制功能
import VueClipboard from 'vue-clipboard2'

Vue.component("tagSelect",tagSelect)
// Vue.use(tagSelect);

Vue.use(VueClipboard)

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 99999
  }
})
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
Vue.use(ElementUI);
Vue.config.productionTip = false
//turnValToText  wordData
Vue.filter('turnValToText', function (val,objKey) {
	let result=""
	let word=wordData[objKey]
  if (!val){
		result=""
	} else if(!word){
		console.log("没有配置"+objKey+'相关数据字典')
		result="-"
	}else{
		word.forEach(function(item,index){
			if(item.value==val){
				result=item.text
				return
			}
		})
	}
	return result
})
Vue.filter('getInt', function (val) {
	let result=""
    if(parseInt(val)){
        result=parseInt(val)
    }else{
        result="-"
    }
	return result
})
Vue.filter('turnStatus', function (val) {
	let result=""
  let word=[{text:'等待审核',value:'p'},{text:'已通过',value:'y'},{text:'拒绝',value:'n'}]
  word.forEach(function(item,index){
    if(item.value==val){
      result=item.text
      return
    }
  })
	return result
})

// 价格转换为保留两位小数
Vue.filter('tablePrice', function (value) {
  if (!value) return '/'
  if (!/^(\d*)(\.\d{1,})?$/.test(value)) return '/'
  return parseFloat(value).toFixed(2)
})
Vue.prototype.trimAll=function(str){
  if(!str){
    return ""
  }else{
    let result= str.replace(/\s*/g,"");
    return result
  }
  
}

// 公共配置
Vue.prototype.$sysConfig = sysConfig

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js